<ion-header>
    <app-header></app-header>
</ion-header>
<ion-content [fullscreen]="true">
    <h1>{{ "__TEST_ZOOM_MEETING_SDK_SAMPLE_ANGULAR__" | translate }}</h1>

    <!-- For Component View -->
    <div id="meetingSDKElement">
        <!-- Zoom Meeting SDK Component View Rendered Here -->
    </div>


    <button (click)="getSignature()">{{ "__TEST_JOIN_MEETING__" | translate }}</button>
</ion-content>
